type BrandLogoProps = {
  className?: string;
  imageClassName?: string;
  compact?: boolean;
  withOvalBackdrop?: boolean;
};

export default function BrandLogo({
  className = '',
  imageClassName = '',
  compact = false,
  withOvalBackdrop = false,
}: BrandLogoProps) {
  const ovalBackdropClass = withOvalBackdrop
    ? `rounded-[999px] border border-white/95 bg-white/95 shadow-[0_6px_18px_rgba(15,23,42,0.22)] backdrop-blur-sm ${compact ? 'px-3 py-1.5' : 'p-6 md:p-10'
    }`
    : '';

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <span className={`inline-flex items-center ${ovalBackdropClass}`.trim()}>
        {compact ? (
          <div className="flex items-center gap-2">
            <img
              src="/logos/logo-sans-texte-donkey-travel.png"
              alt="DONKEY TRAVEL Mark"
              className={`h-14 w-auto object-contain ${imageClassName}`}
            />
            <img
              src="/logos/logo-donkey-travel-text-only.png"
              alt="DONKEY TRAVEL"
              className={`h-5 w-auto object-contain ${imageClassName}`}
            />
          </div>
        ) : (
          <img
            src="/logos/logo-horizontal-doney-travel.png"
            alt="DONKEY TRAVEL"
            className={`w-auto object-contain ${imageClassName}`}
          />
        )}
      </span>
    </span>
  );
}
